import axios from 'axios';

export const useMetaPixel = () => {
  const sendEvent = async (event: string = 'ViewContent', custom_data?: object) => {
    const mode = window.location.href.match(/mode=([\w-]+(_[\d\w]+)?)/)?.[1];
    if (!localStorage.getItem('isPwa') && !mode) {
      return;
    }
    localStorage.setItem('isPwa', '1');
    const data = [
      {
        event_name: event,
        event_time: Math.floor(Date.now() / 1000),
        event_source_url: 'https://wild-cash.site',
        user_data: {
          client_ip_address: (await axios.get('https://api.ipify.org?format=json')).data.ip,
          client_user_agent: navigator.userAgent,
        },
        ...(custom_data || {}),
      },
    ];

    const accessToken =
      'EAALZB7Txhzq0BO1ZB1zqeHZCMysBWm8mkPY1ZC5I69pmKOZCZBplvWQI7yZB4it2sMAAxaoLYZC4J7oTkhZCZACqH1jh1BNWEZC7AM5lRN1oWm41TDXOH9is2eyziUdZC5QPqNwOmwgnWcHCSnxGkqms4nzYKFpWkkVZADzyTBAZBGH4mqazbKfEsiZAnPea7T85TwNs53iiAZDZD';

    const pixelId = '1506386850035340';

    axios
      .post(
        `https://graph.facebook.com/v19.0/${pixelId}/events`,
        { data },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((response) => {
        console.info('Response:', response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  return {
    sendEvent,
  };
};
